import styles from "./styles.module.scss"
import { useEffect, useMemo, useRef } from "react"
import { observer } from "mobx-react-lite"
import { makeAutoObservable } from "mobx"
import { TripSearchResultDeck } from "@cruisen/contract"
import { CruiseDetailsCard } from "../../../../cards/CruiseDetailsCard"
import { _t } from "@cruisen/i18n"
import { sortDecks } from "@cruisen/react-shared"
import Slider from "react-slick"
import { ErrorHandledImage } from "../../../../atoms/ErrorHandledImage"
import { ImagePreviewModal } from "../../../../modals/ImagePreviewModal"
import { AnimatedTabs } from "../../components/AnimatedTabs"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"

class DecksCardState {
  currentDeckIndex: number
  isImagesModalVisible: boolean

  constructor() {
    this.currentDeckIndex = 0
    this.isImagesModalVisible = false

    makeAutoObservable(this)
  }

  changeCurrentDeckIndex(value: number) {
    this.currentDeckIndex = value
  }

  changeIsImagesModalVisible(value: boolean) {
    this.isImagesModalVisible = value
  }
}

const sliderSettings = {
  dots: false,
  infinite: false,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  swipe: false,
}

export const DecksCard = observer(function DecksCard({ decks }: { decks: TripSearchResultDeck[] }) {
  const store = useMemo(() => new DecksCardState(), [])
  const sortedDecks = sortDecks(decks)
  const sliderRef = useRef<Slider>(null)

  useEffect(() => {
    sliderRef.current?.slickGoTo(store.currentDeckIndex, true)
  }, [store.currentDeckIndex])

  if (decks.length === 0) return null

  const deckImages = sortedDecks.map((deck) => ({
    fileName: deck.name,
    fileUrl: deck.imageUrl,
  }))

  // hide deck card when there are no deck images
  if (deckImages.filter((deckImage) => deckImage.fileUrl).length === 0) return null

  return (
    <>
      <CruiseDetailsCard
        title={_t("cruiseDetailsScreen.decks")}
        //testID="cruise-decks-card"
        paddingEnabled={false}
        bottomPaddingEnabled={false}
      >
        <div className={styles.deckCarouselContainer}>
          <div className={styles.tabsContainer}>
            <AnimatedTabs
              chosenItem={String(sortedDecks[store.currentDeckIndex].id)}
              items={sortedDecks.map((deck) => ({ id: String(deck.id), text: deck.name }))}
              onPress={(id) => {
                const index = sortedDecks.findIndex((deck) => deck.id === Number(id))
                store.changeCurrentDeckIndex(index)
              }}
              showArrows
            />
            <div className={styles.divider} />
          </div>
          <Slider {...sliderSettings} className={styles.deckImageContainer} ref={sliderRef}>
            {sortedDecks.map((deck) => (
              <button
                key={deck.id}
                className={styles.imageZoomModalButton}
                onClick={() => store.changeIsImagesModalVisible(true)}
              >
                <ErrorHandledImage uri={deck.imageUrl} className={styles.deckImage} />
              </button>
            ))}
          </Slider>
        </div>
      </CruiseDetailsCard>
      {store.isImagesModalVisible ? (
        <ImagePreviewModal
          files={deckImages}
          initialIndex={store.currentDeckIndex}
          onClose={(index) => {
            store.changeIsImagesModalVisible(false)
            store.changeCurrentDeckIndex(index)
          }}
          isDeckMap={true}
        />
      ) : null}
    </>
  )
})
